<ng-progress-bar
    [speed]="speed"
    [positionUsing]="positionUsing"
    [ease]="ease"
    [showSpinner]="showSpinner"
    [direction]="direction"
    [color]="color"
    [thick]="thick"
    [state]="progress.state$ | async"
></ng-progress-bar>
